import React from 'react';
import PropTypes from 'prop-types';
import strings from '../locales/';

const TagsDisplay = props => {
  var groupedTags = {};
  var groupedArray = [];

  for (var i = 0; i < props.filter.length; i++) {
    groupedTags[props.filter[i].name.toLowerCase()] =
      props.language.filter[props.filter[i].name.toLowerCase()] + ': ';
  }

  for (var i = 0; i < props.tags.length; i++) {
    var category = props.tags[i].tagCategory.toLowerCase();
    var tag = props.tags[i].tag == "*" ? "Todos" : props.tags[i].tag;

    if (category in groupedTags) {
      groupedTags[category] = groupedTags[category] + tag;
    }
  }

  for (var key in groupedTags) {
    groupedArray.push(groupedTags[key]);
  }

  return (
    <div className={'tags-display-wrapper'}>
      {groupedArray.map((item, i) => (
        <div key={i}>{item}</div>
      ))}
    </div>
  );
};

export default TagsDisplay;



// WEBPACK FOOTER //
// ./source/client/components/user_profile/tagsDisplay.jsx